import { cn } from "@/lib/cn";

export function Divider({
  className,
  vertical = false
}: {
  className?: string;
  vertical?: boolean;
}) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        vertical
          ? "w-px self-stretch bg-gradient-to-b from-accent/0 via-accent2/22 to-accent/0"
          : "h-px w-full bg-gradient-to-r from-accent/0 via-accent2/22 to-accent/0",
        className
      )}
    />
  );
}

